import React, {Component} from 'react'
import ReactDOM from 'react-dom'

export default class EditButton extends Component {
  _renderEditButton () {
    return (
      <button onClick={(e) => this._setEditing(e, true)} className='avia-button avia-color-theme-color-subtle'>
        Edit
      </button>
    )
  }

  _renderSaveButton () {
    return (
      <React.Fragment>
        <button onClick={(e) => this._setEditing(e, false)} className='avia-button avia-color-theme-color-subtle'>
          Cancel
        </button>
        <button onClick={this._savePrices} className='avia-button avia-color-theme-color-subtle'>
          Save
        </button>
      </React.Fragment>
    )
  }

  _renderButton () {
    return this.props.isEditing ? this._renderSaveButton() : this._renderEditButton()
  }

  _setEditing = (e, edit) => {
    e.preventDefault()
    this.props.onSetEditing(edit)
  }

  _savePrices = (e) => {
    e.preventDefault()
    this.props.onSaveUpdates()
  }

  render () {
    return ReactDOM.createPortal(
      this._renderButton(),
      this.props.portalContainer,
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EditButton.js